"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.SearchComparisonCard = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _cards = require("@site/cards");
var _sharedComponents = require("@site/shared-components");
var _utilities = require("../../utilities");
var _search = _interopRequireDefault(require("@ux/icon/search"));
var _sparklesFilled = _interopRequireDefault(require("@ux/icon/sparkles-filled"));
var _uxUtils = require("@site/ux-utils");
var _reactMintl = require("@godaddy/react-mintl");
const SearchComparisonCard = ({
  type,
  title = '',
  description = '',
  icon,
  iconColor = 'black',
  mediaType = 'image',
  customAnimation = {}
}) => {
  const {
    isMobile
  } = (0, _uxUtils.useDeviceType)();
  const {
    formatMessage
  } = (0, _reactMintl.useIntl)();
  if (!type) return null;
  const iconComponent = icon === 'search' ? _search.default : _sparklesFilled.default;
  const hasCustomAnimation = Object.keys(customAnimation).length !== 0;
  return /*#__PURE__*/_react.default.createElement(_cards.CardStandard, {
    "data-testid": "search-comparison-card",
    card: {
      title,
      description,
      iconComponent,
      iconColor,
      imageUrl: hasCustomAnimation ? '' : (0, _utilities.getSearchCardImgUrl)(type, mediaType),
      containerClassName: 'search-comparison-card-container',
      mediaContainerClassName: 'search-comparison-card-media',
      descriptionClassName: 'ms-1 search-comparison-card-description',
      isMobile,
      customComponent: hasCustomAnimation && /*#__PURE__*/_react.default.createElement(_sharedComponents.TypingEffect, (0, _extends2.default)({}, customAnimation, {
        text: formatMessage({
          id: customAnimation?.text
        })
      }))
    }
  });
};
exports.SearchComparisonCard = SearchComparisonCard;
SearchComparisonCard.propTypes = {
  type: _propTypes.default.string.isRequired,
  title: _propTypes.default.string,
  description: _propTypes.default.string,
  icon: _propTypes.default.string,
  iconColor: _propTypes.default.string,
  mediaType: _propTypes.default.string,
  customAnimation: _propTypes.default.shape({
    text: _propTypes.default.string,
    tldList: _propTypes.default.arrayOf(_propTypes.default.string),
    delay: _propTypes.default.number,
    loopDelay: _propTypes.default.number
  })
};